import RevendaService from "@/services/RevendaService";

export const revenda = {
  namespaced: true,
  state: {
    revenda: {},
  },
  actions: {
    getRevenda({ commit }, payload) {
      return RevendaService.GetRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRevenda({ commit }, payload) {
      return RevendaService.PostRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRevenda({ commit }, payload) {
      return RevendaService.PutRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRevenda({ commit }, payload) {
      return RevendaService.DeleteRevenda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRevendaOData({ commit }, payload) {
      return RevendaService.GetRevendaOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getUltimosAcessos({ commit }) {
      return RevendaService.GetUltimosAcessos().then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default revenda;
